import api from './client'

export interface LeadCall {
  callLogId: string
  direction: string
  status: string
  duration: number
  toNumber: string
  createdAt: string
  recordingId: string | null
}

export type RecordingMatchStatus = 'matched' | 'unmatched' | 'ambiguous'

export interface AdminRecordingRow {
  recordingId: string
  matchStatus: RecordingMatchStatus
  extension: string | null
  agent: string | null
  number: string | null
  leadId: string | null
  name: string
  organizationId: string | null
  callDate: string
  durationSec: number
}

export interface AdminRecordingsResponse {
  data: AdminRecordingRow[]
  meta: { page: number; limit: number; total: number; totalPages: number }
}

export const recordingsApi = {
  // A lead's calls with the matched recording id where one exists.
  listLeadCalls: (companyId: string, leadId: string) =>
    api.get<{ data: LeadCall[]; meta: { total: number } }>(
      `/companies/${companyId}/leads/${leadId}/calls`,
    ),

  // Admin/owner paginated recordings table.
  listAdmin: (companyId: string, params: Record<string, unknown>) =>
    api.get<AdminRecordingsResponse>(`/companies/${companyId}/recordings`, { params }),

  // The <audio> element cannot send the Authorization header, so RecordingPlayer
  // fetches the audio as an authenticated Blob via the axios client and plays it
  // from an object URL. This keeps the stream endpoint Bearer-protected.
  fetchBlob: (companyId: string, recordingId: string) =>
    api.get(`/companies/${companyId}/recordings/${recordingId}/stream`, {
      responseType: 'blob',
    }),
}
